import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW0C00Model } from "../kymw0c00.model";
import { PlessJsonUploadServiceSub } from "src/app/commons/kymw00/pless-json-upload-sub.service";

/**
 * 指示画像を一括取込する
 *
 * @export
 * @class ReferenceImageFileUploadService
 * @extends {PlessUploadService}
 */
@Injectable()
export class ReferenceImageFileUploadService extends PlessJsonUploadServiceSub<any> {

  private model: KYMW0C00Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof ReplaceImageFileUploadService
   */
  private vo: {
    fileRef: File,
  };
  
  private nextFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ReferenceImageFileUploadService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ReferenceImageFileUploadService
   */
  execute(model: KYMW0C00Model, vo: any, nextFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.nextFunc = nextFunc;
    this.sendFile('KYMW0C00ReferenceImageFileUpload', new PlessRequest(), vo.fileRef);
  }

  /** API通信成功時の処理() */
  success(data: any) {
    this.nextFunc(data);
  }
}
